<!-- Section des statistiques en cartes avec image d'en-tête -->
<section class="w-full bg-white rounded-md p-4 shadow">
  <div
    class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 space-y-3 md:space-y-0"
  >
    <h2 class="text-xl sm:text-xl md:text-xl font-bold">
      Statistiques des réunions
    </h2>
  </div>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    <!-- Cartes statistiques -->
    <div class="bg-gray-100 p-4 flex flex-col rounded-md shadow">
      <div class="flex items-center space-x-2">
        <img
          src="/assets/images/background/Vector.svg"
          alt="Total demandes"
          class="w-12 h-12 sm:w-16 sm:h-16"
        />
        <span class="text-lg sm:text-xl text-gray-600">Total réunion </span>
      </div>
      <span class="text-4xl sm:text-5xl font-bold text-gray-600 mt-2">{{
        Total
      }}</span>
    </div>

    <div class="bg-gray-100 p-4 flex flex-col rounded-md shadow">
      <div class="flex items-center space-x-2">
        <img
          src="/assets/images/background/Group5.svg"
          alt="Demandes en attente"
          class="w-12 h-12 sm:w-16 sm:h-16"
        />
        <span class="text-lg sm:text-xl text-gray-600">Réunions à venir</span>
      </div>
      <span class="text-4xl sm:text-5xl font-bold text-gray-600 mt-2">{{
        TotalEnAttente
      }}</span>
    </div>

    <div class="bg-gray-100 p-4 flex flex-col rounded-md shadow">
      <div class="flex items-center space-x-2">
        <img
          src="/assets/images/background/FrameValide.svg"
          alt="Demandes validées"
          class="w-12 h-12 sm:w-16 sm:h-16"
        />
        <span class="text-lg sm:text-xl text-gray-600">Réunions en cours</span>
      </div>
      <span class="text-4xl sm:text-5xl font-bold text-gray-600 mt-2">{{
        TotalEnCours
      }}</span>
    </div>

    <div class="bg-gray-100 p-4 flex flex-col rounded-md shadow">
      <div class="flex items-center space-x-2">
        <img
          src="/assets/images/background/Frame1.svg"
          alt="Demandes rejetées"
          class="w-12 h-12 sm:w-16 sm:h-16"
        />
        <span class="text-lg sm:text-xl text-gray-600">Réunions terminées</span>
      </div>
      <span class="text-4xl sm:text-5xl font-bold text-gray-600 mt-2">{{
        TotalTermines
      }}</span>
    </div>
  </div>
</section>

<!-- Section de la liste des demandes -->
<section class="mt-6 w-full bg-white rounded-md p-2 sm:p-4 shadow relative">
  <!-- Filtres -->
  <h2 class="text-lg sm:text-xl font-semibold px-1 mt-3 mb-4">
    Liste des séances
  </h2>

  <!-- Filtres - Version mobile optimisée -->
  <div
    class="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 gap-4"
  >
    <!--<div class="flex flex-wrap gap-2 mb-4">
       Bouton "Tous" -->
    <!-- <button
        (click)="itemToSearch.status = ''; getSeance()"
        [class.bg-orange-500]="!itemToSearch.status"
        [class.text-white]="!itemToSearch.status"
        class="px-4 py-2 bg-gray-200 hover:bg-orange-400 hover:text-white transition-colors"
      >
        Tout
      </button>

      <button
        (click)="itemToSearch.status = 'TERMINEE'; getSeance()"
        [class.bg-orange-500]="itemToSearch.status === 'TERMINEE'"
        [class.text-white]="itemToSearch.status === 'TERMINEE'"
        class="px-4 py-2 bg-gray-200 hover:bg-orange-400 hover:text-white transition-colors"
      >
        Terminée
      </button> 
      <select
        [(ngModel)]="itemToSearch.status"
        (change)="getSeance()"
        class="px-4 py-2 bg-gray-200 hover:bg-orange-400 hover:text-white transition-colors rounded"
      >
        <option value="">Tout</option>
        <option value="TERMINEE">Terminée</option>
        <option value="EN_COURS">En cours</option>
        <option value="EN_ATTENTE">A venir</option>
      </select>
    </div>-->
    <div class="flex items-center justify-between mb-8 bg-white p-6">
      <div class="flex items-center space-x-4">
        <div class="relative w-full max-w-xs">
          <select
            id="status"
            [(ngModel)]="itemToSearch.status"
            (change)="getSeance()"
            class="pl-4 pr-10 py-2 rounded border w-full appearance-none bg-white"
          >
            <option value="" selected>Tout afficher</option>
            <option value="TERMINEE">Terminée</option>
            <option value="EN_COURS">En cours</option>
            <option value="EN_ATTENTE">À venir</option>
          </select>

          <!-- Icône flèche personnalisée -->
          <div
            class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none"
          >
            <svg
              class="w-4 h-4 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="relative flex flex-col lg:flex-row gap-2 mb-3">
      <div class="relative flex-grow">
        <input
          type="text"
          [(ngModel)]="itemToSearch.searchTerm"
          placeholder="Rechercher ici..."
          (keyup)="onSearchSeance()"
          class="pl-8 gap-2 pr-4 py-2 rounded border w-full"
        />
        <span
          class="bi bi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
        ></span>
      </div>

      <div
        class="flex flex-col sm:flex-row items-start sm:items-center text-sm space-y-2 sm:space-y-0 sm:space-x-2"
      >
        <span class="text-gray-500 mr-2">Du</span>
        <div
          class="bg-white px-2 py-1 rounded border flex items-center mr-2 w-full sm:w-auto h-[50px]"
        >
          <input
            type="date"
            [(ngModel)]="dateDebut"
            (change)="getSeance()"
            id="start-date"
            class="border-none bg-transparent outline-none w-full sm:w-auto h-full"
          />
        </div>
        <span class="text-gray-500 mr-2">Au</span>
        <div
          class="bg-white px-2 py-1 rounded border flex items-center w-full sm:w-auto h-[50px]"
        >
          <input
            [(ngModel)]="dateFin"
            (change)="getSeance()"
            type="date"
            id="end-date"
            class="border-none bg-transparent outline-none w-full sm:w-auto h-full"
          />
        </div>
        <div
          class="flex flex-col px-2 sm:flex-row items-start sm:items-center gap-3 w-full sm:w-auto mt-2 sm:mt-0"
        >
          <button
            type="button"
            (click)="openModal()"
            class="ml-1 bi bi-calendar flex items-center justify-center gap-2 w-full sm:w-48 h-10 bg-orange-400 rounded-md text-white hover:bg-orange-500 transition-all"
          >
            <span>Ajouter une réunion</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Tableau - Version desktop -->
  <div class="hidden lg:block overflow-x-auto bg-white rounded-lg">
    <div class="mb-28">
      <table class="min-w-full">
        <thead>
          <tr class="text-left text-gray-600 border-b">
            <th class="p-3 whitespace-nowrap">
              <span class="font-semibold">N°</span>
            </th>
            <th class="p-3 whitespace-nowrap">
              <span class="font-semibold">Libellé</span>
            </th>
            <th class="p-3 whitespace-nowrap">
              <span class="font-semibold">Lieu</span>
            </th>
            <th class="p-3 whitespace-nowrap">
              <span class="font-semibold">Date</span>
            </th>
            <th class="p-3 whitespace-nowrap">
              <span class="font-semibold">Statut</span>
            </th>
            <th class="p-3 whitespace-nowrap text-center">
              <span class="font-semibold">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody>
          @for(item of itemsReunions; track item.id; let i = $index) {
          <tr class="border-b {{ i % 2 === 0 ? 'bg-white' : 'bg-gray-50' }}">
            <td class="p-3 text-sm">{{ i + 1 }}</td>
            <td class="p-3 text-sm">{{ item.libelle || "-" }}</td>
            <td class="p-3 text-sm">{{ item.lieu || "-" }}</td>
            <td class="p-3 text-sm whitespace-nowrap">
              {{
                item.date ||
                  (item.firstDate && item.lastDate
                    ? item.firstDate + " - " + item.lastDate
                    : "-")
              }}
            </td>
            <td class="p-3">
              <span
                [ngClass]="{
                  'bg-red-100 text-red-600': item.status === 'TERMINEE',
                  'bg-green-100 text-green-600': item.status === 'EN_COURS',
                  'bg-gray-100 text-gray-600': item.status === 'EN_ATTENTE'
                }"
                class="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium"
              >
                <ng-container *ngIf="item.status === 'TERMINEE'">
                  <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M6 2a1 1 0 00-1 1v2h10V3a1 1 0 10-2 0v2H8V3a1 1 0 00-1-1H6zM4 6v11a1 1 0 001 1h10a1 1 0 001-1V6H4z"
                    />
                  </svg>
                  Terminée
                </ng-container>
                <ng-container *ngIf="item.status === 'EN_COURS'">
                  <svg
                    class="w-3 h-3 animate-spin"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 4v1m0 14v1m8-8h1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707m12.728 0l-.707-.707M6.343 6.343l-.707-.707"
                    />
                  </svg>
                  En cours
                </ng-container>
                <ng-container *ngIf="item.status === 'EN_ATTENTE'">
                  <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M10 2a8 8 0 100 16 8 8 0 000-16zm1 8.414V6a1 1 0 10-2 0v5a1 1 0 00.293.707l3 3a1 1 0 001.414-1.414L11 10.414z"
                    />
                  </svg>
                  A Venir
                </ng-container>
              </span>
            </td>
            <td class="p-3 text-center">
              <div class="dropdown relative inline-block">
                <button
                  class="bg-orange-400 text-white px-3 py-2 rounded-md flex items-center justify-center gap-1 text-sm hover:bg-orange-500 transition-colors"
                  (click)="toggleDropdown(item.id)"
                >
                  <span>Actions</span>
                  <i class="bi bi-chevron-down"></i>
                </button>
                <div
                  class="dropdown-menu absolute right-0 mt-2 bg-white shadow-lg rounded-md z-10 w-48"
                  [ngClass]="{ hidden: activeDropdown !== item.id }"
                >
                  <ul class="py-1">
                    <li>
                      <button
                        (click)="openDetailModal(item)"
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      >
                        <i class="bi bi-eye-fill text-orange-500 mr-2"></i>
                        <span>Détails</span>
                      </button>
                    </li>
                    <li>
                      <button
                        (click)="openHistoriqueModal(item.id)"
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      >
                        <i class="bi bi-person-fill text-orange-500 mr-2"></i>
                        <span>Participants</span>
                      </button>
                    </li>
                    <li [hidden]="item.status !== 'EN_ATTENTE'">
                      <button
                        (click)="openModifModal(item)"
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      >
                        <i class="bi bi-pencil-fill text-orange-500 mr-2"></i>
                        <span>Modifier</span>
                      </button>
                    </li>
                    <li [hidden]="item.status !== 'EN_ATTENTE'">
                      <button
                        (click)="confirmDelete(item.id)"
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      >
                        <i class="bi bi-trash-fill text-orange-500 mr-2"></i>
                        <span>Supprimer</span>
                      </button>
                    </li>
                    <!-- <li [hidden]="item.status !== 'TERMINEE'">
                    <button
                      (click)="validerModal(item.id)"
                      class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                    >
                      <i class="bi bi-check2-all me-2 text-orange-500 mr-2"></i>
                      <span>Valider</span>
                    </button>
                  </li> -->
                    <li
                      [hidden]="
                        item.status !== 'TERMINEE' || item.nomValidateur
                      "
                    >
                      <button
                        (click)="confirmValidation(item.id)"
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      >
                        <i
                          class="bi bi-check2-all me-2 text-orange-500 mr-2"
                        ></i>
                        <span>Valider</span>
                      </button>
                    </li>
                    <ng-container
                      *ngIf="
                        item.status === 'EN_ATTENTE' && item.isSeanceMultiple
                      "
                    >
                      <li>
                        <button
                          (click)="Openseances(item)"
                          class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                        >
                          <i
                            class="bi bi-calendar-event-fill text-orange-600 mr-2"
                          ></i>
                          <span>Ordre du jour</span>
                        </button>
                      </li>
                    </ng-container>
                    <li>
                      <button
                        (click)="downloadPresencePdf(item.id)"
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      >
                        <i
                          class="bi bi-file-earmark-pdf-fill text-orange-500 mr-2"
                        ></i>
                        <span>PDF</span>
                      </button>
                    </li>
                    <li>
                      <button
                        (click)="downloadPresenceExcel(item.id)"
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      >
                        <i
                          class="bi bi-file-earmark-excel-fill text-orange-500 mr-2"
                        ></i>
                        <span>Excel</span>
                      </button>
                    </li>
                    <li>
                      <button
                        (click)="downloadQRCode(item.id)"
                        class="w-full text-left text-sm px-4 py-2 hover:bg-gray-100 flex items-center"
                      >
                        <i class="bi bi-download text-orange-500 mr-2"></i>
                        <span>QR Code</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
          } @empty {
          <tr>
            <td colspan="6" class="text-center py-10 text-gray-500">
              Aucune donnée disponible
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- Cards - Version mobile -->
  <div class="lg:hidden space-y-4">
    @for(item of itemsReunions; track item.id; let i = $index) {
    <div class="bg-white border rounded-lg p-4 shadow-sm">
      <!-- En-tête de la carte -->
      <div class="flex justify-between items-start mb-3">
        <div class="flex-1">
          <h3 class="font-medium text-gray-900 text-sm mb-1">
            {{ item.libelle || "Séance #" + (i + 1) }}
          </h3>
          <p class="text-xs text-gray-500">
            {{ item.lieu || "Lieu non spécifié" }}
          </p>
        </div>
        <span
          [ngClass]="{
            'bg-red-100 text-red-600': item.status === 'TERMINEE',
            'bg-green-100 text-green-600': item.status === 'EN_COURS',
            'bg-gray-100 text-gray-600': item.status === 'EN_ATTENTE'
          }"
          class="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ml-2"
        >
          <ng-container *ngIf="item.status === 'TERMINEE'">
            <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path
                d="M6 2a1 1 0 00-1 1v2h10V3a1 1 0 10-2 0v2H8V3a1 1 0 00-1-1H6zM4 6v11a1 1 0 001 1h10a1 1 0 001-1V6H4z"
              />
            </svg>
            Terminée
          </ng-container>
          <ng-container *ngIf="item.status === 'EN_COURS'">
            <svg
              class="w-3 h-3 animate-spin"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4v1m0 14v1m8-8h1M4 12H3m15.364-6.364l-.707.707M6.343 17.657l-.707.707m12.728 0l-.707-.707M6.343 6.343l-.707-.707"
              />
            </svg>
            En cours
          </ng-container>
          <ng-container *ngIf="item.status === 'EN_ATTENTE'">
            <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path
                d="M10 2a8 8 0 100 16 8 8 0 000-16zm1 8.414V6a1 1 0 10-2 0v5a1 1 0 00.293.707l3 3a1 1 0 001.414-1.414L11 10.414z"
              />
            </svg>
            A Venir
          </ng-container>
        </span>
      </div>

      <!-- Informations de la séance -->
      <div class="mb-3">
        <div class="flex items-center text-xs text-gray-600 mb-1">
          <i class="bi bi-calendar3 mr-2"></i>
          <span>
            {{
              item.date ||
                (item.firstDate && item.lastDate
                  ? item.firstDate + " - " + item.lastDate
                  : "Date non définie")
            }}
          </span>
        </div>
      </div>

      <!-- Actions -->
      <div class="border-t pt-3">
        <div class="flex flex-wrap gap-2">
          <button
            (click)="openDetailModal(item)"
            class="flex items-center gap-1 px-3 py-1.5 bg-orange-50 text-orange-600 rounded-md text-xs hover:bg-orange-100 transition-colors"
          >
            <i class="bi bi-eye-fill"></i>
            <span>Détails</span>
          </button>

          <button
            (click)="openHistoriqueModal(item.id)"
            class="flex items-center gap-1 px-3 py-1.5 bg-orange-50 text-orange-600 rounded-md text-xs hover:bg-orange-100 transition-colors"
          >
            <i class="bi bi-person-fill"></i>
            <span>Participants</span>
          </button>

          <ng-container *ngIf="item.status === 'EN_ATTENTE'">
            <button
              (click)="openModifModal(item)"
              class="flex items-center gap-1 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-md text-xs hover:bg-blue-100 transition-colors"
            >
              <i class="bi bi-pencil-fill"></i>
              <span>Modifier</span>
            </button>

            <button
              (click)="confirmDelete(item.id)"
              class="flex items-center gap-1 px-3 py-1.5 bg-red-50 text-red-600 rounded-md text-xs hover:bg-red-100 transition-colors"
            >
              <i class="bi bi-trash-fill"></i>
              <span>Supprimer</span>
            </button>
          </ng-container>

          <!-- Menu déroulant pour les actions secondaires -->
          <div class="relative">
            <button
              (click)="toggleDropdown(item.id)"
              class="flex items-center gap-1 px-3 py-1.5 bg-gray-50 text-gray-600 rounded-md text-xs hover:bg-gray-100 transition-colors"
            >
              <i class="bi bi-three-dots"></i>
              <span>Plus</span>
            </button>

            <div
              class="absolute right-0 mt-1 bg-white shadow-lg rounded-md z-10 w-40"
              [ngClass]="{ hidden: activeDropdown !== item.id }"
            >
              <ul class="py-1">
                <ng-container
                  *ngIf="item.status === 'EN_ATTENTE' && item.isSeanceMultiple"
                >
                  <li>
                    <button
                      (click)="Openseances(item)"
                      class="w-full text-left text-xs px-3 py-2 hover:bg-gray-100 flex items-center"
                    >
                      <i
                        class="bi bi-calendar-event-fill text-orange-600 mr-2"
                      ></i>
                      <span>Ordre du jour</span>
                    </button>
                  </li>
                </ng-container>
                <li>
                  <button
                    (click)="downloadPresencePdf(item.id)"
                    class="w-full text-left text-xs px-3 py-2 hover:bg-gray-100 flex items-center"
                  >
                    <i
                      class="bi bi-file-earmark-pdf-fill text-orange-500 mr-2"
                    ></i>
                    <span>PDF</span>
                  </button>
                </li>
                <li>
                  <button
                    (click)="downloadPresenceExcel(item.id)"
                    class="w-full text-left text-xs px-3 py-2 hover:bg-gray-100 flex items-center"
                  >
                    <i
                      class="bi bi-file-earmark-excel-fill text-orange-500 mr-2"
                    ></i>
                    <span>Excel</span>
                  </button>
                </li>
                <li>
                  <button
                    (click)="downloadQRCode(item.id)"
                    class="w-full text-left text-xs px-3 py-2 hover:bg-gray-100 flex items-center"
                  >
                    <i class="bi bi-download text-orange-500 mr-2"></i>
                    <span>QR Code</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    } @empty {
    <div class="text-center py-10">
      <div class="text-gray-400 mb-2">
        <i class="bi bi-calendar-x text-3xl"></i>
      </div>
      <p class="text-gray-500 text-sm">Aucune séance trouvée</p>
    </div>
    }
  </div>

  <!-- Pagination -->
  <div
    class="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4 p-3 bg-gray-50 rounded-lg"
  >
    <div class="flex items-center text-sm text-gray-600">
      <span>Total : {{ totalItems || 0 }} éléments</span>
    </div>

    <div class="flex items-center">
      <mat-paginator
        class="mat-paginator-mobile"
        [pageSizeOptions]="[5, 10, 20, 40]"
        [pageIndex]="currentPage"
        [pageSize]="itemsPerPage"
        [length]="totalItems"
        [hidePageSize]="false"
        (page)="pageChanged($event)"
      >
      </mat-paginator>
    </div>
  </div>
</section>

<!-- modal pour les multiples seance -->
@if (showModalSeanceMultiple) {
<div
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-2 sm:p-4"
>
  <div
    class="bg-white w-full max-w-sm sm:max-w-md md:max-w-2xl lg:max-w-4xl max-h-[95vh] sm:max-h-[90vh] rounded-lg shadow-lg flex flex-col"
  >
    <!-- Header -->
    <div
      class="px-3 sm:px-4 md:px-6 py-3 sm:py-4 bg-gray-100 border-b border-gray-200 flex justify-between items-center rounded-t-lg flex-shrink-0"
    >
      <h3
        class="text-base sm:text-lg md:text-xl font-medium text-gray-900 pr-2"
      >
        {{ isEditMode ? "Modifier l'ordre du jour" : "Créer un ordre du jour" }}
      </h3>
      <button
        (click)="closeModalSeanceMultiple()"
        class="p-1 sm:p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded-full flex-shrink-0 transition-colors"
      >
        <i class="bi bi-x-lg text-sm sm:text-base"></i>
      </button>
    </div>

    <!-- Indicateur de chargement -->
    @if (loading) {
    <div class="flex justify-center items-center p-6 sm:p-8">
      <div
        class="animate-spin rounded-full h-6 w-6 sm:h-8 sm:w-8 border-b-2 border-orange-500"
      ></div>
      <span class="ml-2 text-sm sm:text-base">Chargement...</span>
    </div>
    } @if (!loading) {
    <div class="flex-1 overflow-hidden flex flex-col">
      <!-- Formulaire -->
      <div class="bg-gray-50 p-3 sm:p-4 md:p-6 mb-2 flex-shrink-0">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
          <!-- Colonne gauche -->
          <div class="space-y-3 sm:space-y-4">
            <div class="form-group">
              <label
                class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2"
              >
                Date du jour <span class="text-red-500">*</span>
              </label>
              <input
                type="date"
                [(ngModel)]="ordre.dateJour"
                class="w-full h-9 sm:h-10 md:h-11 border border-gray-300 px-2 sm:px-3 py-2 rounded-md text-sm sm:text-base focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
            </div>
            <div class="form-group">
              <label
                class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2"
              >
                Description
              </label>
              <textarea
                [(ngModel)]="ordre.description"
                class="w-full border border-gray-300 px-2 sm:px-3 py-2 rounded-md text-sm sm:text-base focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
                rows="2"
                placeholder="Description de la réunion"
              ></textarea>
            </div>
          </div>

          <!-- Colonne droite -->
          <div class="space-y-3 sm:space-y-4">
            <div class="form-group">
              <label
                class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2"
              >
                Heure Début <span class="text-red-500">*</span>
              </label>
              <input
                type="time"
                [(ngModel)]="ordre.heureDebut"
                class="w-full h-9 sm:h-10 md:h-11 border border-gray-300 px-2 sm:px-3 py-2 rounded-md text-sm sm:text-base focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
            </div>
            <div class="form-group">
              <label
                class="block text-xs sm:text-sm font-medium text-gray-700 mb-1 sm:mb-2"
              >
                Heure Fin <span class="text-red-500">*</span>
              </label>
              <input
                type="time"
                [(ngModel)]="ordre.heureFin"
                class="w-full h-9 sm:h-10 md:h-11 border border-gray-300 px-2 sm:px-3 py-2 rounded-md text-sm sm:text-base focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              />
            </div>
          </div>
        </div>

        <!-- Boutons du formulaire -->
        <div class="flex justify-end mt-4 sm:mt-6 gap-2 sm:gap-3">
          <button
            (click)="resetForm()"
            class="flex-1 sm:flex-none px-4 sm:px-6 py-2 sm:py-2.5 bg-gray-700 text-white rounded-md hover:bg-gray-800 text-sm sm:text-base transition-colors"
          >
            Annuler
          </button>
          <button
            (click)="addMultipleSeance()"
            class="flex-1 sm:flex-none px-4 sm:px-6 py-2 sm:py-2.5 bg-orange-500 text-white rounded-md hover:bg-orange-600 disabled:opacity-50 text-sm sm:text-base transition-colors"
          >
            {{ isEditing ? "Modifier" : "Ajouter" }}
          </button>
        </div>
      </div>

      <!-- Liste des séances -->
      <div
        class="bg-white rounded-md shadow-sm mx-2 sm:mx-4 md:mx-6 mb-2 flex-1 overflow-hidden flex flex-col"
      >
        <div
          class="flex flex-col sm:flex-row sm:justify-between sm:items-center p-3 sm:p-4 border-b gap-2"
        >
          <h4 class="font-medium text-gray-900 text-sm sm:text-base">
            Liste des séances
          </h4>
          @if (isEditMode) {
          <span class="text-xs sm:text-sm text-orange-600 font-medium"
            >Mode édition</span
          >
          }
        </div>

        <div class="flex-1 overflow-hidden">
          <!-- Version mobile (écrans < sm) -->
          <div class="sm:hidden">
            <div class="max-h-[200px] overflow-y-auto">
              <div
                *ngIf="seances.length === 0"
                class="py-8 px-4 text-center text-gray-500 italic text-sm"
              >
                {{
                  isEditMode
                    ? "Aucun ordre du jour trouvé"
                    : "Aucune séance ajoutée"
                }}
              </div>
              <div
                *ngFor="let seance of seances; let i = index"
                class="border-b border-gray-100 last:border-b-0 p-3 hover:bg-gray-50"
              >
                <div class="flex justify-between items-start mb-2">
                  <span
                    class="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded"
                    >{{ i + 1 }}</span
                  >
                  <div class="flex space-x-2">
                    <button
                      (click)="editSeance(seance, i)"
                      class="text-blue-600 hover:text-blue-800 p-1"
                      title="Modifier"
                    >
                      <i class="bi bi-pencil text-sm"></i>
                    </button>
                    <button
                      (click)="removeSeance(i, seance.id)"
                      class="text-red-600 hover:text-red-800 p-1"
                      title="Supprimer"
                    >
                      <i class="bi bi-trash text-sm"></i>
                    </button>
                  </div>
                </div>
                <div class="space-y-1">
                  <div class="text-sm font-medium text-gray-900">
                    {{ seance.description || "-" }}
                  </div>
                  <div class="text-xs text-gray-600">{{ seance.dateJour }}</div>
                  <div class="text-xs text-gray-600">
                    {{ seance.heureDebut }} - {{ seance.heureFin }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Version desktop (écrans >= sm) -->
          <div class="hidden sm:block">
            <table class="min-w-full bg-white">
              <thead class="bg-gray-50 text-xs uppercase text-gray-700">
                <tr>
                  <th class="py-2 px-3 text-left w-10">#</th>
                  <th class="py-2 px-3 text-left">Description</th>
                  <th class="py-2 px-3 text-left">Date du jour</th>
                  <th class="py-2 px-3 text-left">Horaire</th>
                  <th class="py-2 px-3 text-left w-20">Actions</th>
                </tr>
              </thead>
            </table>

            <div
              class="max-h-[150px] sm:max-h-[200px] overflow-y-auto border-t"
            >
              <table class="min-w-full bg-white">
                <tbody>
                  <tr *ngIf="seances.length === 0">
                    <td
                      colspan="5"
                      class="py-6 px-3 text-center text-gray-500 italic text-sm"
                    >
                      {{
                        isEditMode
                          ? "Aucun ordre du jour trouvé"
                          : "Aucune séance ajoutée"
                      }}
                    </td>
                  </tr>
                  <tr
                    *ngFor="let seance of seances; let i = index"
                    class="border-b hover:bg-gray-50"
                  >
                    <td
                      class="py-2 px-3 text-center text-gray-500 w-10 text-sm"
                    >
                      {{ i + 1 }}
                    </td>
                    <td class="py-2 px-3 font-medium text-sm">
                      {{ seance.description || "-" }}
                    </td>
                    <td
                      class="py-2 px-3 text-center text-gray-600 min-w-[100px] text-sm"
                    >
                      {{ seance.dateJour }}
                    </td>
                    <td class="py-2 px-3 text-center text-gray-600 text-sm">
                      {{ seance.heureDebut }} - {{ seance.heureFin }}
                    </td>
                    <td class="py-2 px-3 w-20">
                      <div class="flex justify-center space-x-2">
                        <button
                          (click)="editSeance(seance, i)"
                          class="text-blue-600 hover:text-blue-800 p-1"
                          title="Modifier"
                        >
                          <i class="bi bi-pencil text-sm"></i>
                        </button>
                        <button
                          (click)="removeSeance(i, seance.id)"
                          class="text-red-600 hover:text-red-800 p-1"
                          title="Supprimer"
                        >
                          <i class="bi bi-trash text-sm"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Indicateur de scroll -->
        <div
          *ngIf="seances.length > 4"
          class="p-2 text-center text-xs text-gray-400 border-t bg-gray-50"
        >
          {{ seances.length }} séances - Faites défiler pour voir toutes les
          séances
        </div>
      </div>
    </div>
    }

    <!-- Footer -->
    <div
      class="sticky bottom-0 z-10 px-3 sm:px-4 md:px-6 py-3 sm:py-4 bg-gray-50 border-t border-gray-200 flex-shrink-0"
    >
      <div class="flex justify-end gap-2 sm:gap-3 w-full">
        <button
          (click)="closeModalSeanceMultiple()"
          class="flex-1 sm:flex-none px-4 sm:px-6 py-2 sm:py-2.5 bg-gray-700 text-white rounded-md hover:bg-gray-800 text-sm sm:text-base transition-colors"
        >
          Annuler
        </button>
        <button
          (click)="saveSeance()"
          [disabled]="loading || seances.length === 0"
          class="flex-1 sm:flex-none px-4 sm:px-6 py-2 sm:py-2.5 bg-orange-500 text-white rounded-md hover:bg-orange-600 disabled:opacity-50 text-sm sm:text-base transition-colors"
        >
          {{ isEditMode ? "Mettre à jour" : "Enregistrer" }}
        </button>
      </div>
    </div>
  </div>
</div>
}

<!-- Modal avec stepper -->
<div
  *ngIf="showModal"
  class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-2 sm:p-4"
>
  <div
    class="bg-white w-full max-w-xs sm:max-w-sm md:max-w-2xl lg:max-w-4xl xl:max-w-5xl rounded-lg shadow-lg max-h-[95vh] overflow-hidden flex flex-col"
  >
    <!-- En-tête du modal -->
    <div
      class="px-3 sm:px-4 md:px-6 py-3 sm:py-4 bg-gray-200 border-b border-gray-100 flex justify-between items-center rounded-t-lg flex-shrink-0"
    >
      <h1
        class="text-base sm:text-lg md:text-xl font-semibold text-black pr-2 break-words"
      >
        {{ isEditMode ? "Modifier une réunion" : "Ajouter une réunion" }}
      </h1>
      <button
        (click)="closeModal()"
        class="p-1 sm:p-2 text-black hover:bg-gray-300 rounded-full flex-shrink-0"
      >
        <i class="bi bi-x-lg text-sm sm:text-base"></i>
      </button>
    </div>

    <!-- En-tête du stepper -->
    <div class="px-3 sm:px-4 md:px-6 pt-3 sm:pt-4 flex-shrink-0">
      <div class="flex justify-between items-center">
        <div
          *ngFor="let step of steps; let i = index"
          class="flex flex-col items-center flex-1 relative"
        >
          <div
            [ngClass]="{
              'bg-orange-500 text-white': currentStep >= i,
              'bg-gray-300 text-gray-600': currentStep < i
            }"
            class="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center font-bold z-10 relative text-xs sm:text-sm md:text-base"
          >
            {{ i + 1 }}
          </div>
          <span
            class="mt-1 sm:mt-2 text-xs sm:text-sm text-center px-1 hidden sm:block"
            [ngClass]="{
              'text-orange-500 font-medium': currentStep >= i,
              'text-gray-500': currentStep < i
            }"
            >{{ step }}</span
          >

          <!-- Ligne de connexion -->
          <div
            *ngIf="i < steps.length - 1"
            class="absolute top-3 sm:top-4 md:top-5 left-[50%] w-[100%] z-0"
          >
            <div
              class="h-0.5"
              [ngClass]="{
                'bg-orange-500': currentStep > i,
                'bg-gray-300': currentStep <= i
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Corps du modal - Contenu des étapes -->
    <div class="p-6">
      <!-- Étape 1: Détails de la réunion -->
      <div *ngIf="currentStep === 0">
        <div
          class="grid grid-cols-1 md:grid-cols-2 gap-6 h-[400px] overflow-y-auto"
        >
          <!-- Colonne gauche -->
          <div class="space-y-4">
            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Titre de la réunion <span class="text-red-500">*</span>
              </label>
              <input
                [(ngModel)]="reunion.libelle"
                class="w-full h-11 border px-4 py-2 rounded"
                placeholder="Titre de la réunion"
              />
            </div>

            <div class="form-group">
              <div class="form-group">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Lieu <span class="text-red-500">*</span>
                </label>
                <input
                  [(ngModel)]="reunion.lieu"
                  class="w-full h-11 border px-4 py-2 rounded"
                  placeholder="Lieu de la réunion"
                />
              </div>
              <div *ngIf="!reunion.isSeanceMultiple" class="form-group">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Heure Début <span class="text-red-500">*</span>
                </label>
                <input
                  type="time"
                  [(ngModel)]="reunion.heureDebut"
                  class="w-full h-11 border px-4 py-2 rounded"
                />
              </div>
              <div *ngIf="!reunion.isSeanceMultiple" class="form-group">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Heure Fin <span class="text-red-500">*</span>
                </label>
                <input
                  type="time"
                  [(ngModel)]="reunion.heureFin"
                  class="w-full h-11 border px-4 py-2 rounded"
                />
              </div>
              <div class="form-group">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Longitude
                  <!-- <span
                    class="text-red-500"
                    *ngIf="reunion.typeSeance === 'PRESENTIEL'"
                    >*</span -->
                </label>
                <!-- <input
                  [(ngModel)]="reunion.longitudeLieu"
                  class="w-full h-11 border px-4 py-2 rounded"
                  placeholder="Longitude du lieu de la réunion"
                  [required]="reunion.typeSeance === 'PRESENTIEL'"
                /> -->
                <input
                  [(ngModel)]="reunion.longitudeLieu"
                  (keydown)="validateLongitudeInput($event)"
                  (paste)="validateLongitudePaste($event)"
                  class="w-full h-11 border px-4 py-2 rounded"
                  placeholder="Ex: -4.015125"
                />
                <div *ngIf="longitudeError" class="text-red-500 text-xs mt-1">
                  Format invalide. Exemple accepté: -4.015125
                </div>
              </div>
              <!-- [required]="reunion.typeSeance === 'PRESENTIEL'" -->
              <div class="form-group">
                <label class="block text-sm font-medium text-gray-700 mb-1">
                  Latitude
                  <!-- <span
                    class="text-red-500"
                    *ngIf="reunion.typeSeance === 'PRESENTIEL'"
                    >*</span
                  > -->
                </label>
                <input
                  [(ngModel)]="reunion.latitudeLieu"
                  (keydown)="validateLongitudeInput($event)"
                  (paste)="validateLongitudePaste($event)"
                  class="w-full h-11 border px-4 py-2 rounded"
                  placeholder="Latitude du lieu de la réunion"
                />
              </div>

              <!-- [required]="reunion.typeSeance === 'PRESENTIEL'" -->
            </div>
            <div class="form-group flex">
              <div class="flex items-center">
                <input
                  type="checkbox"
                  id="isSeanceMultiple"
                  [(ngModel)]="reunion.isSeanceMultiple"
                  (change)="onSeanceMultipleChange(reunion.isSeanceMultiple)"
                  class="h-4 w-4 text-orange-500 focus:ring-orange-500 border-gray-300 rounded"
                />
                <label
                  for="isSeanceMultiple"
                  class="ml-2 text-sm text-gray-700"
                >
                  Séance multiple
                </label>
              </div>
            </div>
            <!-- <div class="form-group flex">
              <div class="flex items-center">
                <input
                  type="checkbox"
                  id="isSeanceMultiple"
                  [(ngModel)]="reunion.isSeanceMultiple"
                  class="h-4 w-4 text-orange-500 focus:ring-orange-500 border-gray-300 rounded"
                />
                <label
                  for="isSeanceMultiple"
                  class="ml-2 text-sm text-gray-700"
                >
                  Séance multiple
                </label>
              </div>
            </div> -->
          </div>

          <!-- Colonne droite -->
          <div class="space-y-4">
            <div *ngIf="!reunion.isSeanceMultiple" class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Date <span class="text-red-500">*</span>
              </label>
              <input
                type="date"
                [(ngModel)]="reunion.date"
                class="w-full h-11 border px-4 py-2 rounded"
              />
            </div>
            <div *ngIf="reunion.isSeanceMultiple" class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Date début <span class="text-red-500">*</span>
              </label>
              <input
                type="date"
                [(ngModel)]="reunion.firstDate"
                class="w-full h-11 border px-4 py-2 rounded"
              />
            </div>
            <div *ngIf="reunion.isSeanceMultiple" class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Date fin <span class="text-red-500">*</span>
              </label>
              <input
                type="date"
                [(ngModel)]="reunion.lastDate"
                class="w-full h-11 border px-4 py-2 rounded"
              />
            </div>

            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Rayon de validité (en m)
              </label>
              <input
                [(ngModel)]="reunion.rayonValidite"
                (keydown)="validateNumberInput($event)"
                (paste)="validateNumberPaste($event)"
                class="w-full h-11 border px-4 py-2 rounded"
                placeholder="Rayon en mètres"
              />
            </div>
            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Type de réunion <span class="text-red-500">*</span>
              </label>
              <div class="relative">
                <select
                  [(ngModel)]="reunion.typeSeance"
                  name="typeSeance"
                  class="w-full h-11 border px-4 pr-10 py-2 rounded bg-white text-gray-700"
                  required
                >
                  <option disabled selected value="">
                    Sélectionner un type...
                  </option>
                  <option value="EN_LIGNE">En ligne</option>
                  <option value="PRESENTIEL">En présentiel</option>
                </select>
                <i
                  class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"
                ></i>
              </div>
            </div>

            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Description <span class="text-red-500">*</span>
              </label>
              <textarea
                [(ngModel)]="reunion.description"
                class="w-full border px-4 py-2 rounded"
                rows="3"
                placeholder="Description de la réunion"
              ></textarea>
            </div>
            <div *ngIf="!reunion.isSeanceMultiple" class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Ordre du jour
              </label>
              <textarea
                [(ngModel)]="reunion.ordreDuJour"
                class="w-full border px-4 py-2 rounded"
                rows="3"
                placeholder="Ordre du jour de la réunion"
              ></textarea>
            </div>
            <!-- <div *ngIf="!isSeanceMultiple" class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Ordre du jour
              </label>
              <textarea
                [(ngModel)]="reunion.ordreDuJour"
                class="w-full border px-4 py-2 rounded"
                rows="3"
                placeholder="Ordre du jour de la réunion"
              ></textarea>
            </div> -->
            <div class="flex items-center">
              <input
                type="checkbox"
                id="isPublic"
                [(ngModel)]="reunion.isPublic"
                class="h-4 w-4 text-orange-500 focus:ring-orange-500 border-gray-300 rounded"
              />
              <label for="isPublic" class="ml-2 text-sm text-gray-700">
                Public
              </label>
            </div>
          </div>
          <!-- <div class="form-group flex ">
            <div class="flex items-center">
              <input
                type="checkbox"
                id="isSeanceMultiple"
                [(ngModel)]="reunion.isSeanceMultiple"
                class="h-4 w-4 text-orange-500 focus:ring-orange-500 border-gray-300 rounded"
              />
              <label for="isSeanceMultiple" class="ml-2 text-sm text-gray-700">
                Séance multiple
              </label>
            </div>
          </div> -->
        </div>
      </div>

      <!-- Étape 2: Participants -->
      <div *ngIf="currentStep === 1" class="px-2 sm:px-4">
        <!-- En-tête avec titre et bouton -->
        <div
          class="mb-3 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2"
        >
          <h3 class="text-lg font-medium text-gray-800">Invités</h3>
          <button
            (click)="showAddParticipantForm = true"
            class="px-3 py-2 bg-orange-400 rounded-md text-white hover:bg-orange-500 transition-colors flex items-center justify-center gap-2 text-sm font-medium w-full sm:w-auto"
          >
            <i class="bi bi-person-plus"></i>
            <span class="hidden sm:inline">Ajouter un invité</span>
            <span class="sm:hidden">Ajouter</span>
          </button>
        </div>

        <!-- Formulaire d'ajout de participant -->
        <div
          *ngIf="showAddParticipantForm"
          class="bg-gray-50 p-3 sm:p-4 mb-4 rounded-lg border max-h-[400px] overflow-y-auto"
        >
          <div class="space-y-3">
            <!-- Nom et Prénoms -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Nom</label
                >
                <input
                  [(ngModel)]="newParticipant.nom"
                  maxlength="50"
                  class="w-full h-9 border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                  placeholder="Nom"
                />
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Prénoms</label
                >
                <input
                  [ngModel]="newParticipant.prenoms"
                  maxlength="50"
                  (ngModelChange)="onPrenomChange($event)"
                  class="w-full h-9 border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                  placeholder="Prénoms"
                />
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <!-- Email -->
              <div>
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Email</label
                >
                <input
                  [(ngModel)]="newParticipant.email"
                  maxlength="50"
                  type="email"
                  class="w-full h-9 border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                  placeholder="email@exemple.com"
                />
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Contact</label
                >
                <input
                  maxlength="15"
                  [(ngModel)]="newParticipant.telephone"
                  (keydown)="validateNumberInput($event)"
                  (paste)="validateNumberPaste($event)"
                  class="w-full h-9 border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                  placeholder="Contact"
                />
              </div>
            </div>

            <!-- Contact et Fonction -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Fonction</label
                >
                <input
                  [(ngModel)]="newParticipant.fonction"
                  maxlength="50"
                  class="w-full h-9 border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                  placeholder="Fonction"
                />
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-700 mb-1"
                  >Société</label
                >
                <input
                  [(ngModel)]="newParticipant.societe"
                  maxlength="50"
                  class="w-full h-9 border border-gray-300 px-2 py-1 rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                  placeholder="Société"
                />
              </div>
              <!-- <div>
                <label
                  for="isMail"
                  class="block text-xs font-medium text-gray-700 mb-1"
                >
                  Doit-il reçevoir un mail?
                </label>
                <input
                  type="checkbox"
                  id="isMail"
                  [(ngModel)]="reunion.isMail"
                  (change)="onSeanceMultipleChange(reunion.isMail)"
                  class="w-md h-9 border border-gray-300 px-2 py-1 rounded text-sm"
                />
              </div> -->
            </div>
            <div>
              <div class="flex items-center h-9">
                <input
                  type="checkbox"
                  id="newParticipantMail"
                  [(ngModel)]="newParticipant.isMail"
                  class="h-4 w-4 text-orange-400 focus:ring-orange-400 border-gray-300 rounded"
                />
                <label
                  for="newParticipantMail"
                  class="ml-2 text-sm text-gray-700"
                >
                  Oui, envoyer une invitation
                </label>
              </div>
            </div>
          </div>

          <!-- Boutons d'action -->
          <div class="flex flex-col sm:flex-row justify-end mt-4 gap-2">
            <button
              (click)="showAddParticipantForm = false"
              class="px-3 py-2 bg-gray-300 rounded-md text-gray-700 hover:bg-gray-400 transition-colors text-sm order-2 sm:order-1"
            >
              Annuler
            </button>
            <button
              (click)="addParticipant()"
              class="px-3 py-2 bg-orange-400 rounded-md text-white hover:bg-orange-500 transition-colors text-sm order-1 sm:order-2"
            >
              Ajouter
            </button>
          </div>
        </div>

        <!-- Liste des participants - Version Desktop -->
        <div class="hidden lg:block">
          <div
            class="bg-white rounded-lg shadow-sm border overflow-hidden max-h-[400px] overflow-y-auto"
          >
            <table class="min-w-full">
              <thead class="bg-gray-50 sticky top-0">
                <tr class="text-gray-600 text-sm">
                  <th class="py-3 px-4 text-left font-medium">Nom</th>
                  <th class="py-3 px-4 text-left font-medium">Prénoms</th>
                  <th class="py-3 px-4 text-left font-medium">Email</th>
                  <th class="py-3 px-4 text-left font-medium">Contact</th>
                  <th class="py-3 px-4 text-left font-medium">Fonction</th>
                  <th class="py-3 px-4 text-center font-medium">Société</th>
                  <th class="py-3 px-4 text-center font-medium">Invitation</th>

                  <th class="py-3 px-4 text-center font-medium">Actions</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <!-- Ligne vide -->
                <tr *ngIf="participants.length === 0">
                  <td colspan="6" class="py-8 text-center text-gray-500">
                    <div class="flex flex-col items-center justify-center">
                      <i class="bi bi-people text-3xl mb-2 text-gray-400"></i>
                      <p class="text-sm">Aucun invité ajouté</p>
                    </div>
                  </td>
                </tr>

                <!-- Lignes des participants -->
                <tr
                  *ngFor="let participant of participants; let i = index"
                  class="hover:bg-gray-50 transition-colors"
                >
                  <!-- Mode affichage -->
                  <ng-container *ngIf="!participant.editing; else editMode">
                    <td class="py-3 px-4 text-sm">
                      {{ participant.nom || "-" }}
                    </td>
                    <td class="py-3 px-4 text-sm">
                      {{ participant.prenoms || "-" }}
                    </td>
                    <td class="py-3 px-4 text-sm">
                      {{ participant.email || "-" }}
                    </td>
                    <td class="py-3 px-4 text-sm">
                      {{ participant.telephone || "-" }}
                    </td>
                    <td class="py-3 px-4 text-sm">
                      {{ participant.fonction || "-" }}
                    </td>
                    <td class="py-3 px-4 text-sm">
                      {{ participant.societe || "-" }}
                    </td>
                    <td class="py-3 px-4 text-center">
                      <i
                        class="bi"
                        [class.bi-check-circle-fill]="participant.isMail"
                        [class.text-green-500]="participant.isMail"
                        [class.bi-x-circle]="!participant.isMail"
                        [class.text-gray-400]="!participant.isMail"
                      ></i>
                    </td>
                    <td class="py-3 px-4 text-center">
                      <div class="flex justify-center space-x-1">
                        <button
                          (click)="editParticipant(i)"
                          class="text-blue-500 hover:text-blue-700 p-1 rounded hover:bg-blue-50 transition-colors"
                        >
                          <i class="bi bi-pencil text-sm"></i>
                        </button>
                        <button
                          (click)="removeParticipant(i)"
                          class="text-red-500 hover:text-red-700 p-1 rounded hover:bg-red-50 transition-colors"
                        >
                          <i class="bi bi-trash text-sm"></i>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Mode édition -->
                  <ng-template #editMode>
                    <td class="py-3 px-4">
                      <input
                        [(ngModel)]="participant.nom"
                        maxlength="50"
                        class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                      />
                    </td>
                    <td class="py-3 px-4">
                      <input
                        [(ngModel)]="participant.prenoms"
                        maxlength="50"
                        class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                      />
                    </td>
                    <td class="py-3 px-4">
                      <input
                        [(ngModel)]="participant.email"
                        maxlength="40"
                        type="email"
                        class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                      />
                    </td>
                    <td class="py-3 px-4">
                      <input
                        [(ngModel)]="participant.telephone"
                        maxlength="20"
                        class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                      />
                    </td>
                    <td class="py-3 px-4">
                      <input
                        [(ngModel)]="participant.fonction"
                        maxlength="20"
                        class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                      />
                    </td>
                    <td class="py-3 px-4">
                      <input
                        [(ngModel)]="participant.societe"
                        maxlength="20"
                        class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                      />
                    </td>
                    <td class="py-3 px-4 text-center">
                      <input
                        type="checkbox"
                        [(ngModel)]="participant.isMail"
                        class="h-4 w-4 text-orange-400 focus:ring-orange-400 border-gray-300 rounded"
                      />
                    </td>

                    <td class="py-3 px-4 text-center">
                      <div class="flex justify-center space-x-1">
                        <button
                          (click)="saveParticipant(i)"
                          class="text-green-500 hover:text-green-700 p-1 rounded hover:bg-green-50 transition-colors"
                        >
                          <i class="bi bi-check-lg text-sm"></i>
                        </button>
                        <button
                          (click)="cancelEdit(i)"
                          class="text-gray-500 hover:text-gray-700 p-1 rounded hover:bg-gray-50 transition-colors"
                        >
                          <i class="bi bi-x-lg text-sm"></i>
                        </button>
                      </div>
                    </td>
                  </ng-template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Liste des participants - Version Mobile/Tablet -->
        <div class="lg:hidden">
          <!-- Message vide -->
          <div
            *ngIf="participants.length === 0"
            class="text-center py-8 text-gray-500"
          >
            <div class="flex flex-col items-center justify-center">
              <i class="bi bi-people text-3xl mb-2 text-gray-400"></i>
              <p class="text-sm">Aucun invité ajouté</p>
            </div>
          </div>

          <!-- Cartes des participants avec scroll -->
          <div class="max-h-[400px] overflow-y-auto space-y-3">
            <div
              *ngFor="let participant of participants; let i = index"
              class="bg-white rounded-lg shadow-sm border"
            >
              <!-- Mode affichage -->
              <div *ngIf="!participant.editing; else editModeCard" class="p-3">
                <!-- En-tête -->
                <div class="flex justify-between items-start mb-2">
                  <div class="flex-1 min-w-0">
                    <h4 class="font-medium text-gray-900 text-sm truncate">
                      {{ participant.nom || "Nom non renseigné" }}
                      <span *ngIf="participant.prenoms" class="font-normal">{{
                        participant.prenoms
                      }}</span>
                    </h4>
                    <p
                      class="text-xs text-orange-600 mt-1"
                      *ngIf="participant.fonction"
                    >
                      {{ participant.fonction }}
                    </p>
                  </div>
                  <div class="flex space-x-1 ml-2 flex-shrink-0">
                    <button
                      (click)="editParticipant(i)"
                      class="text-blue-500 hover:text-blue-700 p-1 rounded hover:bg-blue-50 transition-colors"
                      title="Modifier"
                    >
                      <i class="bi bi-pencil text-sm"></i>
                    </button>
                    <button
                      (click)="removeParticipant(i)"
                      class="text-red-500 hover:text-red-700 p-1 rounded hover:bg-red-50 transition-colors"
                      title="Supprimer"
                    >
                      <i class="bi bi-trash text-sm"></i>
                    </button>
                  </div>
                </div>

                <!-- Informations -->
                <div class="space-y-1">
                  <div
                    *ngIf="participant.email"
                    class="flex items-center space-x-2"
                  >
                    <i
                      class="bi bi-envelope text-gray-400 text-xs w-3 flex-shrink-0"
                    ></i>
                    <span class="text-xs text-gray-600 truncate">{{
                      participant.email
                    }}</span>
                  </div>
                  <div
                    *ngIf="participant.telephone"
                    class="flex items-center space-x-2"
                  >
                    <i
                      class="bi bi-telephone text-gray-400 text-xs w-3 flex-shrink-0"
                    ></i>
                    <span class="text-xs text-gray-600">{{
                      participant.telephone
                    }}</span>
                  </div>
                </div>
              </div>

              <!-- Mode édition -->
              <ng-template #editModeCard>
                <div class="p-3 bg-gray-50">
                  <div class="space-y-3">
                    <!-- Nom et Prénoms -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div>
                        <label
                          class="block text-xs font-medium text-gray-700 mb-1"
                          >Nom</label
                        >
                        <input
                          [(ngModel)]="participant.nom"
                          maxlength="50"
                          class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                          placeholder="Nom"
                        />
                      </div>
                      <div>
                        <label
                          class="block text-xs font-medium text-gray-700 mb-1"
                          >Prénoms</label
                        >
                        <input
                          [(ngModel)]="participant.prenoms"
                          maxlength="50"
                          class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                          placeholder="Prénoms"
                        />
                      </div>
                    </div>

                    <!-- Email -->
                    <div>
                      <label
                        class="block text-xs font-medium text-gray-700 mb-1"
                        >Email</label
                      >
                      <input
                        [(ngModel)]="participant.email"
                        maxlength="40"
                        type="email"
                        class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                        placeholder="Email"
                      />
                    </div>

                    <!-- Contact et Fonction -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div>
                        <label
                          class="block text-xs font-medium text-gray-700 mb-1"
                          >Contact</label
                        >
                        <input
                          [(ngModel)]="participant.telephone"
                          maxlength="20"
                          class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                          placeholder="Contact"
                        />
                      </div>
                      <div>
                        <label
                          class="block text-xs font-medium text-gray-700 mb-1"
                          >Fonction</label
                        >
                        <input
                          [(ngModel)]="participant.fonction"
                          maxlength="20"
                          class="w-full h-8 px-2 py-1 border rounded text-sm focus:ring-1 focus:ring-orange-400 focus:border-transparent"
                          placeholder="Fonction"
                        />
                      </div>
                      <div>
                        <label
                          class="block text-xs font-medium text-gray-700 mb-1"
                        >
                          <input
                            type="checkbox"
                            [(ngModel)]="participant.isMail"
                            class="h-4 w-4 text-orange-400 focus:ring-orange-400 border-gray-300 rounded mr-2"
                          />
                          Recevoir une invitation par email
                        </label>
                      </div>
                    </div>
                  </div>

                  <!-- Boutons d'action -->
                  <div class="flex justify-end space-x-2 mt-3">
                    <button
                      (click)="cancelEdit(i)"
                      class="px-3 py-1 bg-gray-300 rounded text-gray-700 hover:bg-gray-400 transition-colors text-sm"
                    >
                      Annuler
                    </button>
                    <button
                      (click)="saveParticipant(i)"
                      class="px-3 py-1 bg-green-500 rounded text-white hover:bg-green-600 transition-colors text-sm"
                    >
                      Sauvegarder
                    </button>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <!-- Étape 3: Récapitulatif -->
      <div *ngIf="currentStep === 2">
        <h3 class="text-lg font-medium mb-4 px-4 sm:px-0">
          Récapitulatif de la réunion
        </h3>

        <div class="bg-gray-100 p-3 sm:p-6 rounded-lg shadow-sm">
          <!-- Informations de la réunion en fieldset -->
          <fieldset
            class="border border-gray-300 rounded-md p-3 sm:p-4 mb-4 sm:mb-6 bg-white"
          >
            <legend class="text-blue-600 font-medium px-2 text-sm sm:text-base">
              Informations de la réunion
            </legend>

            <!-- Version mobile: liste verticale -->
            <div class="block sm:hidden space-y-3">
              <div class="border-b border-gray-100 pb-2">
                <div class="text-xs text-gray-500 uppercase tracking-wide">
                  Libellé
                </div>
                <div class="font-medium text-gray-900 mt-1">
                  {{ reunion.libelle }}
                </div>
              </div>

              <div class="border-b border-gray-100 pb-2">
                <div class="text-xs text-gray-500 uppercase tracking-wide">
                  Lieu
                </div>
                <div class="font-medium text-gray-900 mt-1">
                  {{ reunion.lieu }}
                </div>
              </div>

              <div class="border-b border-gray-100 pb-2">
                <div class="text-xs text-gray-500 uppercase tracking-wide">
                  Date
                </div>
                <div class="font-medium text-gray-900 mt-1">
                  {{
                    reunion.date
                      ? (reunion.date | date : "dd/MM/yyyy")
                      : reunion.firstDate && reunion.lastDate
                      ? (reunion.firstDate | date : "dd/MM/yyyy") +
                        " - " +
                        (reunion.lastDate | date : "dd/MM/yyyy")
                      : "-"
                  }}
                </div>
              </div>

              <div class="border-b border-gray-100 pb-2">
                <div class="text-xs text-gray-500 uppercase tracking-wide">
                  Horaire
                </div>
                <div class="font-medium text-gray-900 mt-1">
                  {{ reunion.heureDebut + "-" + reunion.heureFin || "-" }}
                </div>
              </div>

              <div>
                <div class="text-xs text-gray-500 uppercase tracking-wide">
                  Description
                </div>
                <div class="font-medium text-gray-900 mt-1">
                  {{ reunion.description || "Non spécifiée" }}
                </div>
              </div>
            </div>

            <!-- Version desktop: grille -->
            <div class="hidden sm:grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="flex flex-wrap">
                <span class="text-gray-600 w-28">Libellé:</span>
                <span class="font-medium">{{ reunion.libelle }}</span>
              </div>

              <div class="flex flex-wrap">
                <span class="text-gray-600 w-28">Lieu:</span>
                <span class="font-medium">{{ reunion.lieu }}</span>
              </div>

              <div class="flex flex-wrap">
                <span class="text-gray-600 w-28">Date:</span>
                <span class="font-medium">
                  {{
                    reunion.date
                      ? (reunion.date | date : "dd/MM/yyyy")
                      : reunion.firstDate && reunion.lastDate
                      ? (reunion.firstDate | date : "dd/MM/yyyy") +
                        " - " +
                        (reunion.lastDate | date : "dd/MM/yyyy")
                      : "-"
                  }}
                </span>
              </div>

              <div class="flex flex-wrap">
                <span class="text-gray-600 w-28">Horaire:</span>
                <span class="font-medium">
                  {{ reunion.heureDebut + "-" + reunion.heureFin || "-" }}
                </span>
              </div>

              <div class="flex flex-wrap col-span-1 md:col-span-2">
                <span class="text-gray-600 w-28 align-top">Description:</span>
                <span class="font-medium flex-1">{{
                  reunion.description || "Non spécifiée"
                }}</span>
              </div>
            </div>
          </fieldset>

          <!-- Participants -->
          <div class="bg-white rounded-md shadow-sm">
            <div class="flex justify-between items-center p-3 sm:p-4 border-b">
              <h4 class="font-medium text-blue-600 text-sm sm:text-base">
                Liste des invités
              </h4>
              <span
                *ngIf="participants.length > 0"
                class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full"
              >
                {{ participants.length }}
                {{ participants.length > 1 ? "personnes" : "personne" }}
              </span>
            </div>

            <!-- Version mobile: cartes -->
            <div class="block sm:hidden">
              <div class="max-h-[300px] overflow-y-auto">
                <div
                  *ngIf="participants.length === 0"
                  class="py-8 text-center text-gray-500 italic"
                >
                  Aucun participant ajouté
                </div>

                <div
                  *ngFor="let participant of participants; let i = index"
                  class="border-b border-gray-100 p-3 last:border-b-0"
                >
                  <div class="flex items-start justify-between">
                    <div class="flex-1">
                      <div class="font-medium text-gray-900 text-sm">
                        {{ participant.nom }} {{ participant.prenoms }}
                      </div>
                      <div class="text-xs text-gray-600 mt-1">
                        {{ participant.email }}
                      </div>
                      <div class="text-xs text-gray-500 mt-1">
                        {{ participant.fonction || "Non spécifiée" }}
                      </div>
                    </div>
                    <div class="text-xs text-gray-400 ml-2">#{{ i + 1 }}</div>
                  </div>
                  <div class="space-y-1">
                    <div
                      *ngIf="participant.email"
                      class="flex items-center space-x-2"
                    >
                      <i
                        class="bi bi-envelope text-gray-400 text-xs w-3 flex-shrink-0"
                      ></i>
                      <span class="text-xs text-gray-600 truncate">{{
                        participant.email
                      }}</span>
                      <i
                        *ngIf="participant.isMail"
                        class="bi bi-check-circle-fill text-green-500 text-xs ml-1"
                        title="Recevra une invitation"
                      ></i>
                    </div>
                    <div
                      *ngIf="participant.telephone"
                      class="flex items-center space-x-2"
                    >
                      <i
                        class="bi bi-telephone text-gray-400 text-xs w-3 flex-shrink-0"
                      ></i>
                      <span class="text-xs text-gray-600">{{
                        participant.telephone
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Version desktop: tableau -->
            <div class="hidden sm:block">
              <div class="max-h-[200px] overflow-y-auto border-t">
                <table class="min-w-full bg-white">
                  <thead
                    class="bg-gray-50 text-xs uppercase text-gray-700 sticky top-0"
                  >
                    <tr>
                      <th class="py-3 px-4 text-left w-10">#</th>
                      <th class="py-3 px-4 text-left">Nom & Prénom</th>
                      <th class="py-3 px-4 text-left">Email</th>
                      <th class="py-3 px-4 text-left">Fonction</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="participants.length === 0">
                      <td
                        colspan="4"
                        class="py-4 px-4 text-center text-gray-500 italic"
                      >
                        Aucun participant ajouté
                      </td>
                    </tr>
                    <tr
                      *ngFor="let participant of participants; let i = index"
                      class="border-b hover:bg-gray-50"
                    >
                      <td class="py-3 px-4 text-gray-500">{{ i + 1 }}</td>
                      <td class="py-3 px-4 font-medium">
                        {{ participant.nom }} {{ participant.prenoms }}
                      </td>
                      <td class="py-3 px-4 text-gray-600">
                        {{ participant.email }}
                      </td>
                      <td class="py-3 px-4 text-gray-600">
                        {{ participant.fonction || "Non spécifiée" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Indication de défilement -->
            <div
              *ngIf="participants.length > 5"
              class="p-3 text-center text-xs text-gray-500 bg-gray-50"
            >
              <span class="sm:hidden"
                >Faites défiler pour voir tous les participants</span
              >
              <span class="hidden sm:inline">{{
                participants.length > 8
                  ? "Faites défiler pour voir tous les participants"
                  : ""
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Étape 4: Confirmation & QR Code -->
      <div *ngIf="currentStep === 3" class="flex flex-col h-full">
        <div class="flex-grow text-center">
          <div class="mb-4 text-green-500">
            <i class="bi bi-check-circle text-5xl"></i>
          </div>
          <h3 class="text-xl font-bold mb-2">
            Réunion {{ isEditMode ? "modifiée" : "créée" }} avec succès!
          </h3>

          <div class="flex flex-col items-center mb-6">
            <img
              *ngIf="itemToSave && itemToSave.lienQrCode"
              [src]="itemToSave.lienQrCode"
              alt="QR Code de la réunion"
              class="w-48 h-48 border"
            />
            <div
              *ngIf="!itemToSave || !itemToSave.lienQrCode"
              class="w-48 h-48 bg-gray-200 flex items-center justify-center border"
            >
              <span class="text-gray-500">QR Code non disponible</span>
            </div>
            <p class="mt-2 text-sm text-gray-600">
              ou
              <a
                href="https://fichepresence.oneci.ci/home/{{
                  itemToSave.referenceSeance
                }}"
                class="text-blue-600 underline"
                target="_blank"
                rel="noopener noreferrer"
                >Cliquez ici</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="px-4 sm:px-6 py-4 border-t border-gray-100">
      <!-- Version mobile (< sm) -->
      <div class="flex flex-col gap-3 sm:hidden">
        <!-- Bouton Précédent en pleine largeur sur mobile -->
        <button
          *ngIf="currentStep > 0 && currentStep < 3"
          (click)="prevStep()"
          class="w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 flex items-center justify-center text-sm"
        >
          <i class="bi bi-arrow-left mr-2"></i> Précédent
        </button>

        <!-- Boutons d'action en ligne sur mobile -->
        <div class="flex flex-row gap-2 w-full">
          <button
            (click)="closeModal()"
            class="flex-1 px-4 py-3 bg-gray-700 text-white rounded-md hover:bg-gray-800 text-sm"
          >
            {{ currentStep === 3 ? "Fermer" : "Annuler" }}
          </button>

          <button
            *ngIf="currentStep < 2"
            (click)="nextStep()"
            class="flex-1 px-4 py-3 bg-orange-400 text-white rounded-md hover:bg-orange-500 flex items-center justify-center text-sm"
          >
            Suivant <i class="bi bi-arrow-right ml-2"></i>
          </button>

          <button
            *ngIf="currentStep === 2"
            (click)="saveReunion()"
            class="flex-1 px-4 py-3 bg-green-500 text-white rounded-md hover:bg-green-600 text-sm"
          >
            {{ isEditMode ? "Mettre à jour" : "Enregistrer" }}
          </button>

          <button
            *ngIf="itemToSave?.id && hasParticipantsWithEmail()"
            (click)="sendInvitations()"
            [disabled]="sendingInvitations"
            class="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center justify-center gap-2 order-1 sm:order-2"
          >
            <i
              *ngIf="sendingInvitations"
              class="bi bi-arrow-clockwise animate-spin"
            ></i>
            <i *ngIf="!sendingInvitations" class="bi bi-envelope"></i>
            <span>{{
              sendingInvitations
                ? "Envoi en cours..."
                : "Envoyer les invitations"
            }}</span>
          </button>
        </div>
      </div>

      <div class="hidden sm:flex justify-between items-center">
        <button
          *ngIf="currentStep > 0 && currentStep < 3"
          (click)="prevStep()"
          class="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100"
        >
          <i class="bi bi-arrow-left mr-2"></i> Précédent
        </button>

        <div *ngIf="currentStep === 0 || currentStep === 3"></div>

        <div class="flex gap-3">
          <button
            (click)="closeModal()"
            class="px-6 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800"
          >
            {{ currentStep === 3 ? "Fermer" : "Annuler" }}
          </button>

          <button
            *ngIf="currentStep < 2"
            (click)="nextStep()"
            class="px-6 py-2 bg-orange-400 text-white rounded-md hover:bg-orange-500"
          >
            Suivant <i class="bi bi-arrow-right ml-2"></i>
          </button>

          <button
            *ngIf="currentStep === 2"
            (click)="saveReunion()"
            class="px-6 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
          >
            {{ isEditMode ? "Mettre à jour" : "Enregistrer" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showModalHistorique) {
<div
  class="fixed inset-0 bg-black/50 flex items-center justify-center p-2 sm:p-4 z-50"
>
  <div
    class="bg-white w-full max-w-7xl max-h-[95vh] flex flex-col rounded-lg shadow-lg"
  >
    <!-- Modal Header -->
    <div
      class="px-4 sm:px-6 py-3 sm:py-4 bg-gray-300 border-b border-gray-100 flex justify-between items-center rounded-t-lg shrink-0"
    >
      <h1 class="text-lg sm:text-xl font-semibold text-black">
        Liste des participants
      </h1>
      <button
        (click)="closeModalHistorique()"
        class="text-black hover:text-gray-700 p-1"
      >
        <i class="bi bi-x-lg text-lg sm:text-xl"></i>
      </button>
    </div>

    <!-- Modal Body avec scroll -->
    <div class="p-3 sm:p-6 overflow-y-auto flex-grow">
      <div class="w-full">
        <!-- Version Desktop/Tablette - Tableau -->
        <div class="hidden md:block overflow-x-auto">
          <table class="min-w-full bg-white border rounded-lg">
            <thead>
              <tr class="bg-gray-100">
                <th
                  class="px-3 py-2 border text-left sticky top-0 bg-gray-100 text-sm font-medium"
                >
                  N°
                </th>
                <th
                  class="px-3 py-2 border text-left sticky top-0 bg-gray-100 text-sm font-medium"
                >
                  Nom
                </th>
                <th
                  class="px-3 py-2 border text-left sticky top-0 bg-gray-100 text-sm font-medium"
                >
                  Prénoms
                </th>
                <th
                  class="px-3 py-2 border text-left sticky top-0 bg-gray-100 text-sm font-medium"
                >
                  Email
                </th>
                <th
                  class="px-3 py-2 border text-left sticky top-0 bg-gray-100 text-sm font-medium"
                >
                  Contact
                </th>
                <th
                  class="px-3 py-2 border text-left sticky top-0 bg-gray-100 text-sm font-medium"
                >
                  Société
                </th>
                <th
                  class="px-3 py-2 border text-left sticky top-0 bg-gray-100 text-sm font-medium"
                >
                  Fonctions
                </th>
                <th
                  class="px-3 py-2 border text-left sticky top-0 bg-gray-100 text-sm font-medium"
                >
                  Signature
                </th>
              </tr>
            </thead>
            <tbody>
              @for (item of getPaginatedHistorique(); track item.id; let i =
              $index) {
              <tr class="hover:bg-gray-50">
                <td class="px-3 py-2 border text-sm">{{ i + 1 }}</td>
                <td class="px-3 py-2 border text-sm">{{ item.nom || "-" }}</td>
                <td class="px-3 py-2 border text-sm">
                  {{ item.prenoms || "-" }}
                </td>
                <td class="px-3 py-2 border text-sm break-all">
                  {{ item.email || "-" }}
                </td>
                <td class="px-3 py-2 border text-sm">
                  {{ item.telephone || "-" }}
                </td>
                <td class="px-3 py-2 border text-sm">
                  {{ item.societe || "-" | uppercase }}
                </td>
                <td class="px-3 py-2 border text-sm">
                  {{ item.fonction || "-" }}
                </td>
                <td class="px-3 py-2 border text-center">
                  <img
                    *ngIf="item.signature"
                    [src]="item.signature"
                    alt="signature"
                    class="w-16 h-16 border mx-auto object-contain"
                  />
                  <div
                    *ngIf="!item.signature"
                    class="w-16 h-16 bg-gray-200 flex items-center justify-center border mx-auto"
                  >
                    <span class="text-gray-500 text-xs">-</span>
                  </div>
                </td>
              </tr>
              } @if (!historiqueItems || historiqueItems.length === 0) {
              <tr>
                <td
                  colspan="8"
                  class="px-3 py-4 border text-center text-sm text-gray-500"
                >
                  Aucun historique disponible
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Version Mobile - Cards -->
        <div class="md:hidden space-y-4">
          @for (item of getPaginatedHistorique(); track item.id; let i = $index)
          {
          <div class="bg-white border rounded-lg p-4 shadow-sm">
            <div class="flex justify-between items-start mb-3">
              <div class="flex-1">
                <h3 class="font-medium text-gray-900 text-sm">
                  {{ (item.nom || "") + " " + (item.prenoms || "") }}
                </h3>
                <p class="text-xs text-gray-500 mt-1">
                  Participant #{{ i + 1 }}
                </p>
              </div>
              <div class="ml-3 flex-shrink-0">
                <img
                  *ngIf="item.signature"
                  [src]="item.signature"
                  alt="signature"
                  class="w-12 h-12 border object-contain"
                />
                <div
                  *ngIf="!item.signature"
                  class="w-12 h-12 bg-gray-200 flex items-center justify-center border"
                >
                  <span class="text-gray-500 text-xs">-</span>
                </div>
              </div>
            </div>

            <div class="space-y-2">
              <div class="flex flex-col sm:flex-row sm:justify-between">
                <div class="flex-1 mb-2 sm:mb-0">
                  <p class="text-xs text-gray-600">Email</p>
                  <p class="text-sm font-medium break-all">
                    {{ item.email || "-" }}
                  </p>
                </div>
                <div class="flex-1 sm:ml-4">
                  <p class="text-xs text-gray-600">Contact</p>
                  <p class="text-sm font-medium">{{ item.telephone || "-" }}</p>
                </div>
              </div>

              <div class="flex flex-col sm:flex-row sm:justify-between">
                <div class="flex-1 mb-2 sm:mb-0">
                  <p class="text-xs text-gray-600">Société</p>
                  <p class="text-sm font-medium">
                    {{ item.societe || "-" | uppercase }}
                  </p>
                </div>
                <div class="flex-1 sm:ml-4">
                  <p class="text-xs text-gray-600">Fonction</p>
                  <p class="text-sm font-medium">{{ item.fonction || "-" }}</p>
                </div>
              </div>
            </div>
          </div>
          } @if (!historiqueItems || historiqueItems.length === 0) {
          <div class="text-center py-8 text-gray-500">
            <p class="text-sm">Aucun historique disponible</p>
          </div>
          }
        </div>

        <!-- Pagination et contrôles -->
        <div
          class="mt-4 sm:mt-6 flex flex-col lg:flex-row justify-between items-center gap-4 p-3 bg-gray-50 rounded-lg"
        >
          <div
            class="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full lg:w-auto"
          >
            <!-- Boutons d'export (commentés dans l'original) -->
            <!-- <button
              (click)="exportToExcel()"
              class="px-3 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 flex items-center justify-center text-sm"
              [disabled]="!historiqueItems || historiqueItems.length === 0"
            >
              <i class="bi bi-file-excel mr-2"></i> Excel
            </button>
            <button
              (click)="exportToPDF()"
              class="px-3 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 flex items-center justify-center text-sm"
              [disabled]="!historiqueItems || historiqueItems.length === 0"
            >
              <i class="bi bi-file-pdf mr-2"></i> PDF
            </button> -->
          </div>

          <div
            class="flex flex-col sm:flex-row items-center gap-4 w-full lg:w-auto"
          >
            <!-- Pagination -->
            <div class="w-full sm:w-auto">
              <mat-paginator
                [pageSizeOptions]="[5, 10, 20, 40, 80]"
                [pageIndex]="currentPageHistorique"
                [pageSize]="itemsPerPageHistorique"
                [length]="totalHistorique"
                (page)="pageChangedHistorique($event)"
                class="text-sm"
              >
              </mat-paginator>
            </div>

            <!-- Total -->
            <span class="text-sm font-medium text-gray-700 whitespace-nowrap">
              Total : {{ totalHistorique || 0 }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div
      class="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-100 flex justify-end shrink-0"
    >
      <button
        (click)="closeModalHistorique()"
        class="px-4 sm:px-6 py-2 sm:py-2.5 bg-black text-white rounded-md hover:bg-gray-800 transition-colors text-sm sm:text-base"
      >
        Fermer
      </button>
    </div>
  </div>
</div>
}
<!-- Modal Détail -->
@if (showDetailModal) {
<div
  class="fixed inset-0 bg-black/50 flex items-center justify-center p-4 sm:p-6 md:p-8 z-50"
>
  <div
    class="bg-white w-full max-w-sm sm:max-w-md md:max-w-3xl lg:max-w-4xl xl:max-w-3xl rounded-lg shadow-lg max-h-[90vh] sm:max-h-[85vh] md:max-h-[90vh] flex flex-col mx-4 sm:mx-6 md:mx-8 my-4 sm:my-6 md:my-8"
  >
    <!-- Modal Header -->
    <div
      class="px-4 sm:px-6 py-4 bg-gray-100 border-b border-gray-200 flex justify-between rounded-t-lg shrink-0"
    >
      <h1 class="text-lg sm:text-xl font-semibold text-black">
        Détails de la réunion
      </h1>
      <button
        (click)="closeDetailModal()"
        class="text-gray-500 hover:text-black p-1"
      >
        <i class="bi bi-x-lg text-lg sm:text-xl"></i>
      </button>
    </div>

    @if (isLoadingDetail) {
    <div class="p-6 flex justify-center items-center h-64">
      <div
        class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-black"
      ></div>
    </div>
    } @else {
    <div class="p-4 sm:p-6 overflow-y-auto flex-1">
      <div class="w-full">
        <!-- Informations de la réunion -->
        <fieldset class="border rounded-md p-3 sm:p-4 mb-4 sm:mb-6">
          <legend class="px-2 font-medium text-gray-700 text-sm sm:text-base">
            Réunion
          </legend>
          <div
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4"
          >
            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Libellé
              </label>
              <p
                class="border px-3 sm:px-4 py-2 bg-gray-50 rounded text-sm sm:text-base break-words"
              >
                {{ selectedItem.libelle }}
              </p>
            </div>
            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Date
              </label>
              <p
                class="border px-3 sm:px-4 py-2 bg-gray-50 rounded text-sm sm:text-base"
              >
                {{ selectedItem.date }}
              </p>
            </div>
            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Heure Début
              </label>
              <p
                class="border px-3 sm:px-4 py-2 bg-gray-50 rounded text-sm sm:text-base"
              >
                {{ selectedItem.heureDebut }}
              </p>
            </div>
            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Heure Fin
              </label>
              <p
                class="border px-3 sm:px-4 py-2 bg-gray-50 rounded text-sm sm:text-base"
              >
                {{ selectedItem.heureFin || "-" }}
              </p>
            </div>
            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Lieu
              </label>
              <p
                class="border px-3 sm:px-4 py-2 bg-gray-50 rounded text-sm sm:text-base break-words"
              >
                {{ selectedItem.lieu || "-" }}
              </p>
            </div>
            <div class="form-group">
              <label class="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <p
                class="border px-3 sm:px-4 py-2 bg-gray-50 rounded text-sm sm:text-base break-words"
              >
                {{ selectedItem.description || "-" }}
              </p>
            </div>
            <div class="form-group sm:col-span-2 lg:col-span-3">
              <label
                class="block text-center text-sm font-medium text-gray-700 mb-1"
              >
                QR Code
              </label>
              <div class="flex flex-col items-center mb-4 sm:mb-6">
                <img
                  *ngIf="selectedItem.lienQrCode"
                  [src]="selectedItem.lienQrCode"
                  alt="QR Code de la réunion"
                  class="w-32 h-32 sm:w-48 sm:h-48 border"
                />
                <div
                  *ngIf="!selectedItem.lienQrCode"
                  class="w-32 h-32 sm:w-48 sm:h-48 bg-gray-200 flex items-center justify-center border"
                >
                  <span class="text-gray-500 text-sm">Aucun QR code</span>
                </div>

                <p
                  class="mt-2 text-xs sm:text-sm text-gray-600 text-center px-2"
                >
                  ou
                  <a
                    href="https://fichepresence.oneci.ci/home/{{
                      selectedItem.referenceSeance
                    }}"
                    class="text-blue-600 underline break-all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Cliquez ici</a
                  >
                </p>
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Ordre du jour -->
        <fieldset class="border rounded-md p-3 sm:p-4 mb-4 sm:mb-6">
          <legend class="px-2 font-medium text-gray-700 text-sm sm:text-base">
            Ordre du jour
          </legend>

          @if (ordresDuJour.length === 0) {
          <div class="py-4 text-center text-gray-500 text-sm sm:text-base">
            {{ selectedItem.ordreDuJour || "Aucun ordre du jour" }}
          </div>
          } @else {
          <div class="overflow-x-auto">
            <table class="min-w-full bg-white border rounded-lg">
              <thead>
                <tr class="bg-gray-100 text-gray-700">
                  <th
                    class="py-2 px-2 sm:px-4 border-b text-left text-xs sm:text-sm"
                  >
                    Date
                  </th>
                  <th
                    class="py-2 px-2 sm:px-4 border-b text-left text-xs sm:text-sm"
                  >
                    Heure Début
                  </th>
                  <th
                    class="py-2 px-2 sm:px-4 border-b text-left text-xs sm:text-sm"
                  >
                    Heure Fin
                  </th>
                  <th
                    class="py-2 px-2 sm:px-4 border-b text-left text-xs sm:text-sm"
                  >
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (item of ordresDuJour; track item.id) {
                <tr class="border-b hover:bg-gray-50">
                  <td class="py-2 px-2 sm:px-4 text-xs sm:text-sm">
                    {{ item.dateJour || "-" }}
                  </td>
                  <td class="py-2 px-2 sm:px-4 text-xs sm:text-sm">
                    {{ item.heureDebut || "-" }}
                  </td>
                  <td class="py-2 px-2 sm:px-4 text-xs sm:text-sm">
                    {{ item.heureFin || "-" }}
                  </td>
                  <td class="py-2 px-2 sm:px-4 text-xs sm:text-sm break-words">
                    {{ item.description || "-" }}
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
          }
        </fieldset>
      </div>
    </div>
    }

    <!-- Modal Footer -->
    <div
      class="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 flex justify-end shrink-0"
    >
      <button
        (click)="closeDetailModal()"
        class="px-4 sm:px-6 py-2 sm:py-2.5 bg-black text-white rounded-md hover:bg-gray-800 transition-colors text-sm sm:text-base"
      >
        Fermer
      </button>
    </div>
  </div>
</div>
}
